import React from 'react';
import {
  ColorSwatch,
  Group,
  Paper,
  SimpleGrid,
  Stack,
  Text,
  Title,
} from '@mantine/core';
import { useAuth } from '../contexts/AuthContext.tsx';
import { Layout } from '../components/Layout.tsx';
import { UpdatePassword } from '../components/UpdatePassword.tsx';
import { PageHeader } from '../components/app/index.ts';

const Field = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => (
  <Stack gap={4}>
    <Text size="sm" c="dimmed" fw={500}>
      {label}
    </Text>
    {children}
  </Stack>
);

export const Configuration: React.FC = () => {
  const { project } = useAuth();

  if (!project) {
    return <Text>No project configuration available</Text>;
  }

  return (
    <Layout>
      <PageHeader title="Project Configuration" />

      <Stack gap="lg">
        <Paper withBorder shadow="sm" p={{ base: 'md', sm: 'lg' }}>
          <Stack gap="lg">
            <Stack gap="sm">
              <Title order={4}>Basic Information</Title>
              <SimpleGrid cols={2}>
                <Field label="Project Name">
                  <Text>{project.name}</Text>
                </Field>
                <Field label="Company Name">
                  <Text>{project.company?.name}</Text>
                </Field>
              </SimpleGrid>
            </Stack>

            <Stack gap="sm">
              <Title order={4}>Color Scheme</Title>
              <SimpleGrid cols={2}>
                <Field label="Primary Color">
                  <Group gap="xs">
                    <ColorSwatch
                      color={project.color_scheme?.primary || 'transparent'}
                      size={24}
                      radius="sm"
                    />
                    <Text>{project.color_scheme?.primary}</Text>
                  </Group>
                </Field>
                <Field label="Secondary Color">
                  <Group gap="xs">
                    <ColorSwatch
                      color={project.color_scheme?.secondary || 'transparent'}
                      size={24}
                      radius="sm"
                    />
                    <Text>{project.color_scheme?.secondary}</Text>
                  </Group>
                </Field>
              </SimpleGrid>
            </Stack>
          </Stack>
        </Paper>

        <UpdatePassword />
      </Stack>
    </Layout>
  );
};
